import React, { ReactElement, useState } from 'react'; // Importando useState
import Link from 'next/link';
import { Table } from 'antd';
import { extractFacilityName } from './TitleParkingAt';
import { MinusOutlined, PlusOutlined } from './Icons';

export interface IFacilityData {
  airport_id: number;
  facility_id: number;
  url: string;
  title: string;
  facility_branded: number;
  facility_lot?: string;
  facility_url_code: string;
  airport_initials: string;
  airport_name: string;
  facility_product_type: string;
  facility_description: string;
}

export interface ISiteMapData {
  airport_id: number;
  url: string;
  title: string;
}

function SiteMapListChild({ items, facilities }): ReactElement {
  const [expandedRowKey, setExpandedRowKey] = useState<number | null>(null); // Mudança para number | null

  const expandedRowRender = (item: ISiteMapData) => {
    const filteredFacilities = facilities.filter(
      (facility: IFacilityData) => facility.airport_id === item.airport_id
    );

    return (
      <ul>
        {filteredFacilities.map((facility: IFacilityData) => (
          <li
            key={`${item.airport_id}_${facility.facility_id}`}
            className="ml-2 mb-2 px-10 md:px-12"
          >
            <Link
              href={`${facility.url}`}
              className="text-primary hover:underline hover:text-primary "
              target="_blank"
              rel="noopener noreferrer"
              title={extractFacilityName(facility)}
            >
              {extractFacilityName(facility)}
            </Link>
          </li>
        ))}
      </ul>
    );
  };

  const columns = [
    {
      title: 'Airport',
      dataIndex: 'title',
      key: 'title',
      render: (text: string, record: ISiteMapData) => (
        <Link
          href={`${record.url}`}
          className="hover:underline hover:text-primary"
          target="_blank"
          rel="noopener noreferrer"
          title={record.title}
        >
          {text}
        </Link>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      rowKey="airport_id"
      expandable={{
        expandedRowRender,
        rowExpandable: (record) =>
          facilities.some(
            (facility) => facility.airport_id === record.airport_id
          ),
        expandIcon: ({ expanded, onExpand, record }) => {
          const hasChildren = facilities.some(
            (facility) => facility.airport_id === record.airport_id
          );

          if (!hasChildren) return null;
          return expanded ? (
            <MinusOutlined
              className="text-primary"
              onClick={(e) => {
                onExpand(record, e);
                setExpandedRowKey(null);
              }}
            />
          ) : (
            <PlusOutlined
              className="text-primary"
              onClick={(e) => {
                setExpandedRowKey(
                  record.airport_id === expandedRowKey
                    ? null
                    : record.airport_id
                );
                onExpand(record, e);
              }}
            />
          );
        },
        expandedRowKeys: expandedRowKey ? [expandedRowKey] : [],
      }}
      pagination={false}
      showHeader={false}
    />
  );
}

export default SiteMapListChild;
